/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const createPolicyPlanBodyBlockThresholdMin = 0;
export const createPolicyPlanBodyBlockThresholdMax = 1;

export const createPolicyPlanBodyReviewThresholdMin = 0;
export const createPolicyPlanBodyReviewThresholdMax = 1;

export const createPolicyPlanBodySeverityMax = 5;

export const CreatePolicyPlanBody = zod
	.object({
		action_canvas: zod.record(zod.string(), zod.unknown()).optional(),
		block_threshold: zod
			.number()
			.min(createPolicyPlanBodyBlockThresholdMin)
			.max(createPolicyPlanBodyBlockThresholdMax)
			.optional()
			.describe('Block threshold as a decimal'),
		display_name: zod.string().nullish().describe('Policy plan display name'),
		formats: zod
			.array(zod.enum(['text', 'image']))
			.optional()
			.describe('Content formats'),
		praetor_id: zod
			.uuid()
			.nullish()
			.describe(
				"When provided, the new policy plan is also attached as a component on this praetor's draft"
			),
		review_threshold: zod
			.number()
			.min(createPolicyPlanBodyReviewThresholdMin)
			.max(createPolicyPlanBodyReviewThresholdMax)
			.optional()
			.describe('Review threshold as a decimal'),
		severity: zod
			.number()
			.min(1)
			.max(createPolicyPlanBodySeverityMax)
			.nullish()
			.describe('Severity level (1-5)'),
		template_id: zod.string().nullish().describe('Template ID to base this policy plan on')
	})
	.describe('Request body for creating a policy plan');

export type CreatePolicyPlanBody = zod.input<typeof CreatePolicyPlanBody>;
export type CreatePolicyPlanBodyOutput = zod.output<typeof CreatePolicyPlanBody>;
